import { MobileBookingDetailComponent } from '@booking/components/mobile-booking-detail/mobile-booking-detail.component';
import { TermsConditionsComponent } from '@terms-conditions/terms-conditions/terms-conditions.component';
import { PrivatePolicyComponent } from '@privacy-policy/privacy-policy/privacy-policy.component';
import {
  TreatmentPersonalDataComponent
} from '@treatment-personal-data/treatment-personal-data/treatment-personal-data.component';
import { SpecialTravelDataComponent } from '@app/modules/special-travel-data/special-travel-data.component';
import {
  MobilePackageBookingDetailComponent
} from '@booking/containers/mobile-package-booking-detail/mobile-package-booking-detail.container';
import {
  bookingDetailRoute, bookingInnerDetailRoute, bookingUpsellRoute, bookingWaitingPageRoute,
  informativeBookingRoute, informativePaxCelebrateBookingRoute
} from '@booking/constants/booking-routes.constants';
import { MobileUpsellComponent } from '@upsell/components/mobile/mobile-upsell.component';
import { PaxCelebrateContainer } from '@pax/containers/pax-celebrate/pax-celebrate.container';
import { BookingWaitingPageContainer } from '@booking/containers/booking-waiting-page/booking-waiting-page.container';
import { RoutingLevel } from '@ux/animations/animations';
import { HeaderType } from '@design-system/components/templates/header/entities/header.types';
import { HeaderPageType } from '@header/entities/ds-header-config';
import { productResultsDetailOutletRoute } from '@app/constants/app-routing.constants';

const ROUTE_DATA = {
  data: {
    routingLevel: RoutingLevel.Eight,
    dsHeaderConfig: {
      type: HeaderType.Generic,
      titleKey: null,
      pageType: HeaderPageType.BookingPage,
    },
  },
};

const BASE_CHILDREN = [
  {
    path: 'terms',
    outlet: 'terms',
    component: TermsConditionsComponent
  },
  {
    path: 'private-policy',
    outlet: 'terms',
    component: PrivatePolicyComponent
  },
  {
    path: 'treatment-personal-data',
    outlet: 'terms',
    component: TreatmentPersonalDataComponent
  },
  {
    path: 'special-travel-data',
    outlet: 'terms',
    component: SpecialTravelDataComponent
  },
  {
    path: bookingUpsellRoute,
    outlet: 'terms',
    component: MobileUpsellComponent
  },
  {
    path: informativePaxCelebrateBookingRoute,
    outlet: informativeBookingRoute,
    component: PaxCelebrateContainer
  },
  {
    path: bookingWaitingPageRoute,
    outlet: informativeBookingRoute,
    component: BookingWaitingPageContainer
  }
];

export const BOOKING_AIR_PACKAGE_CHILDREN = [
  {
    path: bookingDetailRoute,
    component: MobilePackageBookingDetailComponent,
    children: [
      {
        path: bookingInnerDetailRoute,
        outlet: 'inner-detail',
        component: MobilePackageBookingDetailComponent
      }
    ],
    ...ROUTE_DATA,
  },
  ...BASE_CHILDREN,
];

export const BOOKING_VEHICLE_CHILDREN = [
  {
    path: bookingDetailRoute,
    component: MobileBookingDetailComponent,
    ...ROUTE_DATA,
  },
  {
    path: bookingDetailRoute,
    outlet: 'auto-detail',
    component: MobileBookingDetailComponent
  },
  ...BASE_CHILDREN,
];

export const BOOKING_SIMPLE_CHILDREN = [
  {
    path: bookingDetailRoute,
    component: MobileBookingDetailComponent,
    ...ROUTE_DATA,
  },
  {
    path: bookingDetailRoute,
    outlet: productResultsDetailOutletRoute,
    component: MobileBookingDetailComponent,
    ...ROUTE_DATA,
  },
  {
    path: bookingDetailRoute,
    outlet: 'hotel-detail',
    component: MobileBookingDetailComponent
  },
  ...BASE_CHILDREN,
];
